// 由 scripts/generate-docs-manifest.mjs 生成，请勿手工编辑。
export const sections = [
  {
    "id": "start",
    "zh": "开始使用",
    "en": "Get started"
  },
  {
    "id": "cases",
    "zh": "实战案例",
    "en": "Practical guides"
  },
  {
    "id": "desktop",
    "zh": "桌面端功能",
    "en": "Desktop app"
  },
  {
    "id": "im",
    "zh": "IM 接入",
    "en": "Messaging"
  },
  {
    "id": "cli",
    "zh": "命令行",
    "en": "Command line"
  },
  {
    "id": "internals",
    "zh": "深入原理",
    "en": "Internals"
  }
]

export const docsIndex = [
  {
    "description": "An AI coding workbench that runs on your own machine. You pick the model; you approve every change.",
    "locale": "en",
    "navTitle": "What it is",
    "order": 0,
    "path": "/en/start",
    "section": "start",
    "slug": "en/start",
    "sourcePath": "docs/en/start/index.md",
    "title": "What cc-haha is"
  },
  {
    "description": "Installers for macOS, Windows, and Linux, plus what to do when the OS blocks them.",
    "locale": "en",
    "navTitle": "Install",
    "order": 1,
    "path": "/en/start/install",
    "section": "start",
    "slug": "en/start/install",
    "sourcePath": "docs/en/start/install.md",
    "title": "Download and install"
  },
  {
    "description": "Official accounts, third-party APIs, or a local model — pick one and be running in ten minutes.",
    "locale": "en",
    "navTitle": "Connect a model",
    "order": 2,
    "path": "/en/start/models",
    "section": "start",
    "slug": "en/start/models",
    "sourcePath": "docs/en/start/models.md",
    "title": "Connect a model"
  },
  {
    "description": "Pick a folder, set permissions, state a goal, watch it edit files, review the diff.",
    "locale": "en",
    "navTitle": "First session",
    "order": 3,
    "path": "/en/start/first-session",
    "section": "start",
    "slug": "en/start/first-session",
    "sourcePath": "docs/en/start/first-session.md",
    "title": "Run your first session"
  },
  {
    "description": "Organized by symptom — install failures, blank window, model 401s, stuck sessions, port conflicts, phone access.",
    "locale": "en",
    "navTitle": "Troubleshooting",
    "order": 4,
    "path": "/en/start/troubleshooting",
    "section": "start",
    "slug": "en/start/troubleshooting",
    "sourcePath": "docs/en/start/troubleshooting.md",
    "title": "Won't install, won't open, won't connect"
  },
  {
    "description": "Signing scope, responsible roles, approval, verification, and revocation rules for official cc-haha releases.",
    "locale": "en",
    "navTitle": "Signing policy",
    "order": 5,
    "path": "/en/start/code-signing",
    "section": "start",
    "slug": "en/start/code-signing",
    "sourcePath": "docs/en/start/code-signing.md",
    "title": "Code signing policy"
  },
  {
    "description": "What cc-haha stores locally, when it uses the network, and how to remove its data.",
    "locale": "en",
    "navTitle": "Privacy",
    "order": 6,
    "path": "/en/start/privacy",
    "section": "start",
    "slug": "en/start/privacy",
    "sourcePath": "docs/en/start/privacy.md",
    "title": "Privacy and network access"
  },
  {
    "description": "Five real tasks to practice with cc-haha, from understanding a project to scheduled work and phone access.",
    "locale": "en",
    "navTitle": "Guide overview",
    "order": 0,
    "path": "/en/cases",
    "section": "cases",
    "slug": "en/cases",
    "sourcePath": "docs/en/cases/index.md",
    "title": "Practical guides: from goal to verification"
  },
  {
    "description": "Use Plan mode to identify entry points, run commands, and important modules, then verify each claim.",
    "locale": "en",
    "navTitle": "Explore a project",
    "order": 1,
    "path": "/en/cases/explore-project",
    "section": "cases",
    "slug": "en/cases/explore-project",
    "sourcePath": "docs/en/cases/explore-project.md",
    "title": "Understand an unfamiliar project in 10 minutes"
  },
  {
    "description": "Give Claude reproduction steps, ask it to identify the cause and add a test, then review a focused fix.",
    "locale": "en",
    "navTitle": "Fix a bug",
    "order": 2,
    "path": "/en/cases/fix-bug",
    "section": "cases",
    "slug": "en/cases/fix-bug",
    "sourcePath": "docs/en/cases/fix-bug.md",
    "title": "Fix a bug and check for regressions"
  },
  {
    "description": "Turn a web request into verifiable steps, preview the page, and give precise diff feedback.",
    "locale": "en",
    "navTitle": "Build a web feature",
    "order": 3,
    "path": "/en/cases/ship-feature",
    "section": "cases",
    "slug": "en/cases/ship-feature",
    "sourcePath": "docs/en/cases/ship-feature.md",
    "title": "Build a feature and preview the page"
  },
  {
    "description": "Create a scheduled task that reports findings, run it immediately, and inspect the result in the logs.",
    "locale": "en",
    "navTitle": "Daily review",
    "order": 4,
    "path": "/en/cases/daily-review",
    "section": "cases",
    "slug": "en/cases/daily-review",
    "sourcePath": "docs/en/cases/daily-review.md",
    "title": "Set up a daily code review"
  },
  {
    "description": "Open Phone connection and use a browser on the same Wi-Fi to continue a task running on your computer.",
    "locale": "en",
    "navTitle": "Phone handoff",
    "order": 5,
    "path": "/en/cases/phone-handoff",
    "section": "cases",
    "slug": "en/cases/phone-handoff",
    "sourcePath": "docs/en/cases/phone-handoff.md",
    "title": "Continue a session on your phone"
  },
  {
    "description": "Everything the desktop app can do, on one screen, with a link to each page.",
    "locale": "en",
    "navTitle": "Feature map",
    "order": 0,
    "path": "/en/desktop",
    "section": "desktop",
    "slug": "en/desktop",
    "sourcePath": "docs/en/desktop/index.md",
    "title": "Desktop feature map"
  },
  {
    "description": "A session from first question to reviewed diff, and which button to press when Claude asks.",
    "locale": "en",
    "navTitle": "Sessions",
    "order": 1,
    "path": "/en/desktop/sessions",
    "section": "desktop",
    "slug": "en/desktop/sessions",
    "sourcePath": "docs/en/desktop/sessions.md",
    "title": "Sessions, permissions, and review"
  },
  {
    "description": "The right-hand panel — see what changed, review the diff line by line, preview a page in-app.",
    "locale": "en",
    "navTitle": "Workspace",
    "order": 2,
    "path": "/en/desktop/workspace",
    "section": "desktop",
    "slug": "en/desktop/workspace",
    "sourcePath": "docs/en/desktop/workspace.md",
    "title": "Workspace"
  },
  {
    "description": "When to delegate, which agents ship built in, and how to write your own.",
    "locale": "en",
    "navTitle": "Subagents",
    "order": 3,
    "path": "/en/desktop/agents",
    "section": "desktop",
    "slug": "en/desktop/agents",
    "sourcePath": "docs/en/desktop/agents.md",
    "title": "Subagents"
  },
  {
    "description": "A skill is a ready-made procedure for Claude. What to check before installing one.",
    "locale": "en",
    "navTitle": "Skills",
    "order": 4,
    "path": "/en/desktop/skills",
    "section": "desktop",
    "slug": "en/desktop/skills",
    "sourcePath": "docs/en/desktop/skills.md",
    "title": "Skills and the Skills Market"
  },
  {
    "description": "Schedule a conversation to continue later, edit recurring plans, and read actual execution results.",
    "locale": "en",
    "navTitle": "Scheduled tasks",
    "order": 5,
    "path": "/en/desktop/schedule",
    "section": "desktop",
    "slug": "en/desktop/schedule",
    "sourcePath": "docs/en/desktop/schedule.md",
    "title": "Scheduled tasks"
  },
  {
    "description": "Choose the settings needed for a first session, then find advanced options by task.",
    "locale": "en",
    "navTitle": "Settings",
    "order": 6,
    "path": "/en/desktop/settings",
    "section": "desktop",
    "slug": "en/desktop/settings",
    "sourcePath": "docs/en/desktop/settings.md",
    "title": "Settings guide"
  },
  {
    "description": "Let Claude read interfaces and operate desktop apps on macOS, Windows, and Linux.",
    "locale": "en",
    "navTitle": "Computer Use",
    "order": 7,
    "path": "/en/desktop/computer-use",
    "section": "desktop",
    "slug": "en/desktop/computer-use",
    "sourcePath": "docs/en/desktop/computer-use.md",
    "title": "Computer Use"
  },
  {
    "description": "A little robot on your desktop that shows you how the current task is going.",
    "locale": "en",
    "navTitle": "Desktop pet",
    "order": 8,
    "path": "/en/desktop/pets",
    "section": "desktop",
    "slug": "en/desktop/pets",
    "sourcePath": "docs/en/desktop/pets.md",
    "title": "Desktop pet"
  },
  {
    "description": "Open Phone connection to continue tasks in a browser, check mobile app availability, and set up access away from home.",
    "locale": "en",
    "navTitle": "Phone and IM",
    "order": 9,
    "path": "/en/desktop/remote",
    "section": "desktop",
    "slug": "en/desktop/remote",
    "sourcePath": "docs/en/desktop/remote.md",
    "title": "Mobile App, H5, and IM"
  },
  {
    "description": "Bridge Feishu, Telegram, WeChat, DingTalk, WhatsApp, WeCom, QQ, or Slack private chats into the Desktop app and continue the same session from your phone.",
    "locale": "en",
    "navTitle": "Overview",
    "order": 0,
    "path": "/en/im",
    "section": "im",
    "slug": "en/im",
    "sourcePath": "docs/en/im/index.md",
    "title": "IM Integrations"
  },
  {
    "description": "Scan a QR code in Settings to create a Feishu bot, then drive Desktop sessions from a private chat with card-based approval.",
    "locale": "en",
    "navTitle": "Feishu",
    "order": 1,
    "path": "/en/im/feishu",
    "section": "im",
    "slug": "en/im/feishu",
    "sourcePath": "docs/en/im/feishu.md",
    "title": "Feishu Integration"
  },
  {
    "description": "Get a Bot Token from BotFather, paste it into Desktop, and approve permissions with native buttons.",
    "locale": "en",
    "navTitle": "Telegram",
    "order": 2,
    "path": "/en/im/telegram",
    "section": "im",
    "slug": "en/im/telegram",
    "sourcePath": "docs/en/im/telegram.md",
    "title": "Telegram Integration"
  },
  {
    "description": "Scan a QR code in Settings to log in a WeChat bot account, then authorize individual users with a pairing code.",
    "locale": "en",
    "navTitle": "WeChat",
    "order": 3,
    "path": "/en/im/wechat",
    "section": "im",
    "slug": "en/im/wechat",
    "sourcePath": "docs/en/im/wechat.md",
    "title": "WeChat Integration"
  },
  {
    "description": "Authorize a DingTalk bot by QR code and run over DingTalk Stream, with no public callback URL required.",
    "locale": "en",
    "navTitle": "DingTalk",
    "order": 4,
    "path": "/en/im/dingtalk",
    "section": "im",
    "slug": "en/im/dingtalk",
    "sourcePath": "docs/en/im/dingtalk.md",
    "title": "DingTalk Integration"
  },
  {
    "description": "Scan from Linked devices on your phone to attach the Desktop app as a logged-in WhatsApp Web device.",
    "locale": "en",
    "navTitle": "WhatsApp",
    "order": 5,
    "path": "/en/im/whatsapp",
    "section": "im",
    "slug": "en/im/whatsapp",
    "sourcePath": "docs/en/im/whatsapp.md",
    "title": "WhatsApp Integration"
  },
  {
    "description": "Scan a QR code in Settings to create an Enterprise WeChat AI bot, then drive the Desktop app from a private chat with streaming replies.",
    "locale": "en",
    "navTitle": "WeCom",
    "order": 6,
    "path": "/en/im/wecom",
    "section": "im",
    "slug": "en/im/wecom",
    "sourcePath": "docs/en/im/wecom.md",
    "title": "WeCom Integration"
  },
  {
    "description": "Scan a QR code in Settings to authorize a QQ bot, then drive the Desktop app from a private chat with streaming replies.",
    "locale": "en",
    "navTitle": "QQ",
    "order": 7,
    "path": "/en/im/qq",
    "section": "im",
    "slug": "en/im/qq",
    "sourcePath": "docs/en/im/qq.md",
    "title": "QQ Integration"
  },
  {
    "description": "Create a Slack app from a pre-filled manifest and drive the Desktop app from direct messages over Socket Mode.",
    "locale": "en",
    "navTitle": "Slack",
    "order": 8,
    "path": "/en/im/slack",
    "section": "im",
    "slug": "en/im/slack",
    "sourcePath": "docs/en/im/slack.md",
    "title": "Slack Integration"
  },
  {
    "description": "Run the CLI from source - install dependencies, configure a provider, launch from any directory.",
    "locale": "en",
    "navTitle": "Install and Run",
    "order": 0,
    "path": "/en/cli",
    "section": "cli",
    "slug": "en/cli",
    "sourcePath": "docs/en/cli/index.md",
    "title": "Install and Run"
  },
  {
    "description": "Interactive sessions, --print headless mode, recovery mode, and common command-line flags.",
    "locale": "en",
    "navTitle": "Commands",
    "order": 1,
    "path": "/en/cli/reference",
    "section": "cli",
    "slug": "en/cli/reference",
    "sourcePath": "docs/en/cli/reference.md",
    "title": "Command Reference"
  },
  {
    "description": "Authentication, model, Azure, and local-runtime variables, plus the real precedence order.",
    "locale": "en",
    "navTitle": "Env Vars",
    "order": 2,
    "path": "/en/cli/env",
    "section": "cli",
    "slug": "en/cli/env",
    "sourcePath": "docs/en/cli/env.md",
    "title": "Environment Variables"
  },
  {
    "description": "How the five layers divide the work, how one message flows through them, and which page to read for the change you want to make.",
    "locale": "en",
    "navTitle": "Architecture",
    "order": 0,
    "path": "/en/internals",
    "section": "internals",
    "slug": "en/internals",
    "sourcePath": "docs/en/internals/index.md",
    "title": "Architecture Overview"
  },
  {
    "description": "Process boundaries between the Electron main process, server sidecar, CLI subprocesses, and IM adapters.",
    "locale": "en",
    "navTitle": "Desktop",
    "order": 1,
    "path": "/en/internals/desktop",
    "section": "internals",
    "slug": "en/internals/desktop",
    "sourcePath": "docs/en/internals/desktop.md",
    "title": "Desktop Architecture"
  },
  {
    "description": "Startup flags, access control, REST surface, and chat WebSocket of the local server.",
    "locale": "en",
    "navTitle": "Local Server",
    "order": 2,
    "path": "/en/internals/server",
    "section": "internals",
    "slug": "en/internals/server",
    "sourcePath": "docs/en/internals/server.md",
    "title": "Local Server and API"
  },
  {
    "description": "Responsibility boundaries across the CLI, server, desktop app, adapters, and docs site.",
    "locale": "en",
    "navTitle": "Structure",
    "order": 3,
    "path": "/en/internals/structure",
    "section": "internals",
    "slug": "en/internals/structure",
    "sourcePath": "docs/en/internals/structure.md",
    "title": "Project Structure"
  },
  {
    "description": "Built-in agents, spawn options, background tasks, Agent Teams, and custom agent definitions.",
    "locale": "en",
    "navTitle": "Multi-Agent Usage",
    "order": 4,
    "path": "/en/internals/agent",
    "section": "internals",
    "slug": "en/internals/agent",
    "sourcePath": "docs/en/internals/agent.md",
    "title": "Multi-Agent Usage Guide"
  },
  {
    "description": "Spawn paths, tool pool filtering, context passing, and the background task engine.",
    "locale": "en",
    "navTitle": "Multi-Agent Internals",
    "order": 5,
    "path": "/en/internals/agent-internals",
    "section": "internals",
    "slug": "en/internals/agent-internals",
    "sourcePath": "docs/en/internals/agent-internals.md",
    "title": "Multi-Agent Internals"
  },
  {
    "description": "The core agent loop, prompt engineering, tool system, and context compression, read from source.",
    "locale": "en",
    "navTitle": "Agent Framework",
    "order": 6,
    "path": "/en/internals/agent-framework",
    "section": "internals",
    "slug": "en/internals/agent-framework",
    "sourcePath": "docs/en/internals/agent-framework.md",
    "title": "Agent Framework Deep Dive"
  },
  {
    "description": "Skill sources, definition format, invocation, execution context, and permission control.",
    "locale": "en",
    "navTitle": "Skills Usage",
    "order": 7,
    "path": "/en/internals/skills",
    "section": "internals",
    "slug": "en/internals/skills",
    "sourcePath": "docs/en/internals/skills.md",
    "title": "Skills Usage Guide"
  },
  {
    "description": "How skills are discovered, parsed, injected into conversations, and run in fork subagents.",
    "locale": "en",
    "navTitle": "Skills Internals",
    "order": 8,
    "path": "/en/internals/skills-internals",
    "section": "internals",
    "slug": "en/internals/skills-internals",
    "sourcePath": "docs/en/internals/skills-internals.md",
    "title": "Skills Internals"
  },
  {
    "description": "The four memory types, how saving is triggered, where memories live, and how to manage them.",
    "locale": "en",
    "navTitle": "Memory Usage",
    "order": 9,
    "path": "/en/internals/memory",
    "section": "internals",
    "slug": "en/internals/memory",
    "sourcePath": "docs/en/internals/memory.md",
    "title": "Memory System Usage Guide"
  },
  {
    "description": "Path resolution, prompt injection, auto-extraction, retrieval, and team memory sync.",
    "locale": "en",
    "navTitle": "Memory Internals",
    "order": 10,
    "path": "/en/internals/memory-internals",
    "section": "internals",
    "slug": "en/internals/memory-internals",
    "sourcePath": "docs/en/internals/memory-internals.md",
    "title": "Memory System Internals"
  },
  {
    "description": "The four-phase background pass that reviews recent sessions and prunes memories.",
    "locale": "en",
    "navTitle": "AutoDream",
    "order": 11,
    "path": "/en/internals/autodream",
    "section": "internals",
    "slug": "en/internals/autodream",
    "sourcePath": "docs/en/internals/autodream.md",
    "title": "AutoDream Memory Consolidation"
  },
  {
    "description": "The macOS native engine, Windows/Linux agent-desktop integration, sessions, and input boundaries.",
    "locale": "en",
    "navTitle": "Computer Use",
    "order": 12,
    "path": "/en/internals/computer-use",
    "section": "internals",
    "slug": "en/internals/computer-use",
    "sourcePath": "docs/en/internals/computer-use.md",
    "title": "Computer Use Architecture"
  },
  {
    "description": "The message protocol, six-layer access control, and permission relay behind IM remote control.",
    "locale": "en",
    "navTitle": "Channel System",
    "order": 13,
    "path": "/en/internals/channel",
    "section": "internals",
    "slug": "en/internals/channel",
    "sourcePath": "docs/en/internals/channel.md",
    "title": "Channel System"
  },
  {
    "description": "Local setup, impact checks, quality gates, testing requirements, and the PR workflow.",
    "locale": "en",
    "navTitle": "Contributing",
    "order": 14,
    "path": "/en/internals/contributing",
    "section": "internals",
    "slug": "en/internals/contributing",
    "sourcePath": "docs/en/internals/contributing.md",
    "title": "Contributing and Quality Gates"
  },
  {
    "description": "Verified contracts for the official plugin, native events, action timing, and batched observations, with current compatibility limits.",
    "locale": "en",
    "navTitle": "Codex Compatibility",
    "order": 15,
    "path": "/en/internals/computer-use-codex-impl-blueprint",
    "section": "internals",
    "slug": "en/internals/computer-use-codex-impl-blueprint",
    "sourcePath": "docs/en/internals/computer-use-codex-impl-blueprint.md",
    "title": "Codex Native Computer Use Compatibility Contracts"
  },
  {
    "description": "跑在你自己电脑上的 AI 编程工作台：模型自己接，改动你审阅。",
    "locale": "zh",
    "navTitle": "这是什么",
    "order": 0,
    "path": "/start",
    "section": "start",
    "slug": "start",
    "sourcePath": "docs/start/index.md",
    "title": "cc-haha 是什么"
  },
  {
    "description": "macOS、Windows、Linux 三个平台的安装包，以及系统拦截时的处理办法。",
    "locale": "zh",
    "navTitle": "下载与安装",
    "order": 1,
    "path": "/start/install",
    "section": "start",
    "slug": "start/install",
    "sourcePath": "docs/start/install.md",
    "title": "下载与安装"
  },
  {
    "description": "官方账号、第三方 API、本地模型，三种接法任选一种，十分钟内跑起来。",
    "locale": "zh",
    "navTitle": "连接模型",
    "order": 2,
    "path": "/start/models",
    "section": "start",
    "slug": "start/models",
    "sourcePath": "docs/start/models.md",
    "title": "连接模型服务"
  },
  {
    "description": "选目录、定权限、说目标、看它改文件、逐行审阅——一轮完整流程。",
    "locale": "zh",
    "navTitle": "第一条会话",
    "order": 3,
    "path": "/start/first-session",
    "section": "start",
    "slug": "start/first-session",
    "sourcePath": "docs/start/first-session.md",
    "title": "跑通第一条会话"
  },
  {
    "description": "按症状查：安装失败、启动白屏、模型 401、会话卡住、端口冲突、手机连不上。",
    "locale": "zh",
    "navTitle": "排查问题",
    "order": 4,
    "path": "/start/troubleshooting",
    "section": "start",
    "slug": "start/troubleshooting",
    "sourcePath": "docs/start/troubleshooting.md",
    "title": "装不上 / 打不开 / 连不上"
  },
  {
    "description": "cc-haha 正式发布包的签名范围、责任角色、审批、验证与撤销规则。",
    "locale": "zh",
    "navTitle": "签名政策",
    "order": 5,
    "path": "/start/code-signing",
    "section": "start",
    "slug": "start/code-signing",
    "sourcePath": "docs/start/code-signing.md",
    "title": "Code signing policy"
  },
  {
    "description": "cc-haha 在本机保存什么、何时访问网络，以及如何清理数据。",
    "locale": "zh",
    "navTitle": "隐私与联网",
    "order": 6,
    "path": "/start/privacy",
    "section": "start",
    "slug": "start/privacy",
    "sourcePath": "docs/start/privacy.md",
    "title": "隐私与联网说明"
  },
  {
    "description": "用五个真实任务练习 cc-haha，从读项目、改代码到定时任务与手机接力。",
    "locale": "zh",
    "navTitle": "案例总览",
    "order": 0,
    "path": "/cases",
    "section": "cases",
    "slug": "cases",
    "sourcePath": "docs/cases/index.md",
    "title": "实战案例：从目标到验收"
  },
  {
    "description": "用计划模式摸清项目入口、运行方法和关键模块，并逐项核对来源。",
    "locale": "zh",
    "navTitle": "读懂项目",
    "order": 1,
    "path": "/cases/explore-project",
    "section": "cases",
    "slug": "cases/explore-project",
    "sourcePath": "docs/cases/explore-project.md",
    "title": "10 分钟读懂陌生项目"
  },
  {
    "description": "把复现步骤交给 Claude，要求先定位原因与测试，再审阅最小修复。",
    "locale": "zh",
    "navTitle": "修复 Bug",
    "order": 2,
    "path": "/cases/fix-bug",
    "section": "cases",
    "slug": "cases/fix-bug",
    "sourcePath": "docs/cases/fix-bug.md",
    "title": "修复 Bug 并检查回归"
  },
  {
    "description": "把一个网页需求拆成可验收的步骤，在工作区预览和逐行反馈。",
    "locale": "zh",
    "navTitle": "做网页功能",
    "order": 3,
    "path": "/cases/ship-feature",
    "section": "cases",
    "slug": "cases/ship-feature",
    "sourcePath": "docs/cases/ship-feature.md",
    "title": "实现功能并预览页面"
  },
  {
    "description": "创建一条只报告问题的定时任务，立即试跑并从日志检查结果。",
    "locale": "zh",
    "navTitle": "每日审查",
    "order": 4,
    "path": "/cases/daily-review",
    "section": "cases",
    "slug": "cases/daily-review",
    "sourcePath": "docs/cases/daily-review.md",
    "title": "建立每日代码审查"
  },
  {
    "description": "从手机连接入口开启浏览器访问，在同一 Wi-Fi 下用手机查看电脑上的任务并继续回复。",
    "locale": "zh",
    "navTitle": "手机接力",
    "order": 5,
    "path": "/cases/phone-handoff",
    "section": "cases",
    "slug": "cases/phone-handoff",
    "sourcePath": "docs/cases/phone-handoff.md",
    "title": "用手机接力当前会话"
  },
  {
    "description": "一屏看懂桌面端有哪些能力，以及每个功能该翻哪一篇。",
    "locale": "zh",
    "navTitle": "功能总览",
    "order": 0,
    "path": "/desktop",
    "section": "desktop",
    "slug": "desktop",
    "sourcePath": "docs/desktop/index.md",
    "title": "桌面端功能总览"
  },
  {
    "description": "一条会话从提问到审阅改动的全过程，以及权限弹窗该怎么点。",
    "locale": "zh",
    "navTitle": "会话与权限",
    "order": 1,
    "path": "/desktop/sessions",
    "section": "desktop",
    "slug": "desktop/sessions",
    "sourcePath": "docs/desktop/sessions.md",
    "title": "会话、权限与审阅"
  },
  {
    "description": "右侧工作区：看改了哪些文件、逐行评审 Diff、在应用里预览网页。",
    "locale": "zh",
    "navTitle": "工作区",
    "order": 2,
    "path": "/desktop/workspace",
    "section": "desktop",
    "slug": "desktop/workspace",
    "sourcePath": "docs/desktop/workspace.md",
    "title": "工作区"
  },
  {
    "description": "什么时候该派子 Agent、内置的有哪些、怎么捏一个自己的。",
    "locale": "zh",
    "navTitle": "子 Agent",
    "order": 3,
    "path": "/desktop/agents",
    "section": "desktop",
    "slug": "desktop/agents",
    "sourcePath": "docs/desktop/agents.md",
    "title": "子 Agent 与任务拆分"
  },
  {
    "description": "技能是给 Claude 的一套现成做法，从市场装之前要看清楚什么。",
    "locale": "zh",
    "navTitle": "技能",
    "order": 4,
    "path": "/desktop/skills",
    "section": "desktop",
    "slug": "desktop/skills",
    "sourcePath": "docs/desktop/skills.md",
    "title": "技能与技能市场"
  },
  {
    "description": "在对话中安排稍后继续或重复任务，编辑计划，并查看实际执行结果。",
    "locale": "zh",
    "navTitle": "定时任务",
    "order": 5,
    "path": "/desktop/schedule",
    "section": "desktop",
    "slug": "desktop/schedule",
    "sourcePath": "docs/desktop/schedule.md",
    "title": "定时任务"
  },
  {
    "description": "从第一条会话出发，选择必要设置，并按任务查找高级配置。",
    "locale": "zh",
    "navTitle": "设置",
    "order": 6,
    "path": "/desktop/settings",
    "section": "desktop",
    "slug": "desktop/settings",
    "sourcePath": "docs/desktop/settings.md",
    "title": "设置指南"
  },
  {
    "description": "在 macOS、Windows 和 Linux 上，让 Claude 读取界面并操作桌面应用。",
    "locale": "zh",
    "navTitle": "Computer Use",
    "order": 7,
    "path": "/desktop/computer-use",
    "section": "desktop",
    "slug": "desktop/computer-use",
    "sourcePath": "docs/desktop/computer-use.md",
    "title": "Computer Use"
  },
  {
    "description": "一只悬浮在桌面上的小机器人，用动作告诉你任务跑到哪了。",
    "locale": "zh",
    "navTitle": "桌面宠物",
    "order": 8,
    "path": "/desktop/pets",
    "section": "desktop",
    "slug": "desktop/pets",
    "sourcePath": "docs/desktop/pets.md",
    "title": "桌面宠物"
  },
  {
    "description": "从手机连接入口用浏览器扫码接力，了解手机 App 发布状态与外出连接方法。",
    "locale": "zh",
    "navTitle": "手机与 IM",
    "order": 9,
    "path": "/desktop/remote",
    "section": "desktop",
    "slug": "desktop/remote",
    "sourcePath": "docs/desktop/remote.md",
    "title": "手机 App、H5 与 IM 接力"
  },
  {
    "description": "把飞书、Telegram、微信、钉钉、WhatsApp、企业微信、QQ 或 Slack 的私聊接到桌面端，用手机继续同一条会话。",
    "locale": "zh",
    "navTitle": "总览",
    "order": 0,
    "path": "/im",
    "section": "im",
    "slug": "im",
    "sourcePath": "docs/im/index.md",
    "title": "IM 接入"
  },
  {
    "description": "在设置页扫码直接创建飞书机器人，在飞书单聊里驱动桌面端并用卡片批权限。",
    "locale": "zh",
    "navTitle": "飞书",
    "order": 1,
    "path": "/im/feishu",
    "section": "im",
    "slug": "im/feishu",
    "sourcePath": "docs/im/feishu.md",
    "title": "飞书接入"
  },
  {
    "description": "找 BotFather 要一个 Bot Token 填进桌面端，在 Telegram 私聊里点按钮批权限。",
    "locale": "zh",
    "navTitle": "Telegram",
    "order": 2,
    "path": "/im/telegram",
    "section": "im",
    "slug": "im/telegram",
    "sourcePath": "docs/im/telegram.md",
    "title": "Telegram 接入"
  },
  {
    "description": "在设置页扫码登录微信机器人账号，再用配对码授权具体微信用户。",
    "locale": "zh",
    "navTitle": "微信",
    "order": 3,
    "path": "/im/wechat",
    "section": "im",
    "slug": "im/wechat",
    "sourcePath": "docs/im/wechat.md",
    "title": "微信接入"
  },
  {
    "description": "用钉钉扫码授权机器人，走 DingTalk Stream 长连接，不需要公网回调地址。",
    "locale": "zh",
    "navTitle": "钉钉",
    "order": 4,
    "path": "/im/dingtalk",
    "section": "im",
    "slug": "im/dingtalk",
    "sourcePath": "docs/im/dingtalk.md",
    "title": "钉钉接入"
  },
  {
    "description": "用手机 WhatsApp 的「已关联设备」扫码，把桌面端挂成一台已登录的 Web 设备。",
    "locale": "zh",
    "navTitle": "WhatsApp",
    "order": 5,
    "path": "/im/whatsapp",
    "section": "im",
    "slug": "im/whatsapp",
    "sourcePath": "docs/im/whatsapp.md",
    "title": "WhatsApp 接入"
  },
  {
    "description": "在设置页扫码创建企业微信智能机器人，在单聊里驱动桌面端，回复流式更新同一条消息。",
    "locale": "zh",
    "navTitle": "企业微信",
    "order": 6,
    "path": "/im/wecom",
    "section": "im",
    "slug": "im/wecom",
    "sourcePath": "docs/im/wecom.md",
    "title": "企业微信接入"
  },
  {
    "description": "在设置页扫码授权 QQ 机器人，在 QQ 私聊里驱动桌面端，回复走 QQ 的流式消息。",
    "locale": "zh",
    "navTitle": "QQ",
    "order": 7,
    "path": "/im/qq",
    "section": "im",
    "slug": "im/qq",
    "sourcePath": "docs/im/qq.md",
    "title": "QQ 接入"
  },
  {
    "description": "用预填好的应用清单创建 Slack App，走 Socket Mode 在私信里驱动桌面端。",
    "locale": "zh",
    "navTitle": "Slack",
    "order": 8,
    "path": "/im/slack",
    "section": "im",
    "slug": "im/slack",
    "sourcePath": "docs/im/slack.md",
    "title": "Slack 接入"
  },
  {
    "description": "从源码运行 CLI：安装依赖、配置模型服务、在任意目录启动。",
    "locale": "zh",
    "navTitle": "安装与启动",
    "order": 0,
    "path": "/cli",
    "section": "cli",
    "slug": "cli",
    "sourcePath": "docs/cli/index.md",
    "title": "安装与启动"
  },
  {
    "description": "交互式会话、--print 无头模式、恢复模式与常用命令行参数。",
    "locale": "zh",
    "navTitle": "命令参考",
    "order": 1,
    "path": "/cli/reference",
    "section": "cli",
    "slug": "cli/reference",
    "sourcePath": "docs/cli/reference.md",
    "title": "命令参考"
  },
  {
    "description": "认证、模型、Azure、本地运行相关的环境变量与实际生效顺序。",
    "locale": "zh",
    "navTitle": "环境变量",
    "order": 2,
    "path": "/cli/env",
    "section": "cli",
    "slug": "cli/env",
    "sourcePath": "docs/cli/env.md",
    "title": "环境变量"
  },
  {
    "description": "五层代码怎么分工，一条消息怎么流过它们，以及改动某块功能该从哪篇读起。",
    "locale": "zh",
    "navTitle": "架构总览",
    "order": 0,
    "path": "/internals",
    "section": "internals",
    "slug": "internals",
    "sourcePath": "docs/internals/index.md",
    "title": "架构总览"
  },
  {
    "description": "Electron 主进程、Server Sidecar、CLI 子进程与 IM Adapter 的进程边界。",
    "locale": "zh",
    "navTitle": "桌面端架构",
    "order": 1,
    "path": "/internals/desktop",
    "section": "internals",
    "slug": "internals/desktop",
    "sourcePath": "docs/internals/desktop.md",
    "title": "桌面端架构"
  },
  {
    "description": "本地 Server 的启动参数、访问控制、REST 与 WebSocket 接口范围。",
    "locale": "zh",
    "navTitle": "本地 Server",
    "order": 2,
    "path": "/internals/server",
    "section": "internals",
    "slug": "internals/server",
    "sourcePath": "docs/internals/server.md",
    "title": "本地 Server 与 API"
  },
  {
    "description": "仓库的目录职责边界：CLI、Server、桌面端、Adapter 与文档站。",
    "locale": "zh",
    "navTitle": "项目结构",
    "order": 3,
    "path": "/internals/structure",
    "section": "internals",
    "slug": "internals/structure",
    "sourcePath": "docs/internals/structure.md",
    "title": "项目结构"
  },
  {
    "description": "内置 Agent、生成方式、后台任务、Agent Teams 与自定义 Agent 的写法。",
    "locale": "zh",
    "navTitle": "多 Agent 使用",
    "order": 4,
    "path": "/internals/agent",
    "section": "internals",
    "slug": "internals/agent",
    "sourcePath": "docs/internals/agent.md",
    "title": "多 Agent 使用指南"
  },
  {
    "description": "多 Agent 的生成路径、工具池过滤、上下文传递与后台任务引擎。",
    "locale": "zh",
    "navTitle": "多 Agent 实现",
    "order": 5,
    "path": "/internals/agent-internals",
    "section": "internals",
    "slug": "internals/agent-internals",
    "sourcePath": "docs/internals/agent-internals.md",
    "title": "多 Agent 实现原理"
  },
  {
    "description": "从源码视角拆解核心 Agent 循环、提示词工程、工具系统与上下文压缩。",
    "locale": "zh",
    "navTitle": "Agent 框架",
    "order": 6,
    "path": "/internals/agent-framework",
    "section": "internals",
    "slug": "internals/agent-framework",
    "sourcePath": "docs/internals/agent-framework.md",
    "title": "Agent 框架深度解析"
  },
  {
    "description": "Skill 的六种来源、定义格式、调用方式、执行上下文与权限控制。",
    "locale": "zh",
    "navTitle": "Skills 使用",
    "order": 7,
    "path": "/internals/skills",
    "section": "internals",
    "slug": "internals/skills",
    "sourcePath": "docs/internals/skills.md",
    "title": "Skills 使用指南"
  },
  {
    "description": "Skill 如何被发现、解析、注入对话、在 fork 子 Agent 中执行。",
    "locale": "zh",
    "navTitle": "Skills 实现",
    "order": 8,
    "path": "/internals/skills-internals",
    "section": "internals",
    "slug": "internals/skills-internals",
    "sourcePath": "docs/internals/skills-internals.md",
    "title": "Skills 实现原理"
  },
  {
    "description": "四种记忆类型、触发保存的方式、存储位置与日常管理办法。",
    "locale": "zh",
    "navTitle": "记忆系统使用",
    "order": 9,
    "path": "/internals/memory",
    "section": "internals",
    "slug": "internals/memory",
    "sourcePath": "docs/internals/memory.md",
    "title": "记忆系统使用指南"
  },
  {
    "description": "路径解析、提示词注入、自动提取、智能检索与团队记忆同步。",
    "locale": "zh",
    "navTitle": "记忆系统实现",
    "order": 10,
    "path": "/internals/memory-internals",
    "section": "internals",
    "slug": "internals/memory-internals",
    "sourcePath": "docs/internals/memory-internals.md",
    "title": "记忆系统实现原理"
  },
  {
    "description": "后台静默回顾近期会话、整合并修剪记忆的四阶段流程与安全限制。",
    "locale": "zh",
    "navTitle": "AutoDream",
    "order": 11,
    "path": "/internals/autodream",
    "section": "internals",
    "slug": "internals/autodream",
    "sourcePath": "docs/internals/autodream.md",
    "title": "AutoDream 记忆整合"
  },
  {
    "description": "macOS 原生引擎、Windows/Linux agent-desktop 接入、会话与输入边界。",
    "locale": "zh",
    "navTitle": "Computer Use",
    "order": 12,
    "path": "/internals/computer-use",
    "section": "internals",
    "slug": "internals/computer-use",
    "sourcePath": "docs/internals/computer-use.md",
    "title": "Computer Use 架构"
  },
  {
    "description": "IM 平台远程控制 Agent 的消息协议、六层访问控制与权限中继。",
    "locale": "zh",
    "navTitle": "Channel 系统",
    "order": 13,
    "path": "/internals/channel",
    "section": "internals",
    "slug": "internals/channel",
    "sourcePath": "docs/internals/channel.md",
    "title": "Channel 系统"
  },
  {
    "description": "本地安装、影响面检查、质量门禁、测试要求与 PR 提交流程。",
    "locale": "zh",
    "navTitle": "参与贡献",
    "order": 14,
    "path": "/internals/contributing",
    "section": "internals",
    "slug": "internals/contributing",
    "sourcePath": "docs/internals/contributing.md",
    "title": "参与贡献与质量门禁"
  },
  {
    "description": "官方插件、原生事件、动作时序与批量观察的已验证契约，以及当前实现的兼容边界。",
    "locale": "zh",
    "navTitle": "Codex 兼容契约",
    "order": 15,
    "path": "/internals/computer-use-codex-impl-blueprint",
    "section": "internals",
    "slug": "internals/computer-use-codex-impl-blueprint",
    "sourcePath": "docs/internals/computer-use-codex-impl-blueprint.md",
    "title": "Codex 原生 Computer Use 兼容契约"
  },
  {
    "description": "对网易云音乐（CEF116）之类的 Chromium 应用，每一次 click / type text 都返回 Action completed. ，而界面 毫无变化 。模型拿到截图看不出所以然，只能反复重试， 最后幻觉出一个\"已完成\"。用户连续两轮拿到的都是不能用的东西。",
    "locale": "zh",
    "navTitle": "CEF/Electron 注入：为什么点击会静默失效",
    "order": 900,
    "path": "/internals/computer-use-cef-injection",
    "section": "internals",
    "slug": "internals/computer-use-cef-injection",
    "sourcePath": "docs/internals/computer-use-cef-injection.md",
    "title": "CEF/Electron 注入：为什么点击会静默失效"
  },
  {
    "description": "All anchors confirmed: CommandRouter.swift:234 awaits the blocking glide before Injection.click at line 237 (the critical-path latency). Transport boundary files and Python dead-we",
    "locale": "zh",
    "navTitle": "Computer Use — 对标 Codex 从底层重设计(规格 + 对抗式审计)",
    "order": 900,
    "path": "/internals/computer-use-codex-redesign",
    "section": "internals",
    "slug": "internals/computer-use-codex-redesign",
    "sourcePath": "docs/internals/computer-use-codex-redesign.md",
    "title": "Computer Use — 对标 Codex 从底层重设计(规格 + 对抗式审计)"
  },
  {
    "description": "五个独立评审员 + 三轮交叉验证的结论汇总。取证以 明文为主 ：Codex 活体 MCP tools/list 、 @oai/sky 的 JS/ .d.ts 明文、以及二进制符号面。",
    "locale": "zh",
    "navTitle": "Computer Use ↔ Codex Parity 评审结论（2026-07-27）",
    "order": 900,
    "path": "/internals/computer-use-codex-parity-review",
    "section": "internals",
    "slug": "internals/computer-use-codex-parity-review",
    "sourcePath": "docs/internals/computer-use-codex-parity-review.md",
    "title": "Computer Use ↔ Codex Parity 评审结论（2026-07-27）"
  },
  {
    "description": "目标：把底层执行层从 pyautogui （HID 层模拟，独占鼠标）替换为原生 Swift helper（按 PID 定向注入 + Accessibility + ScreenCaptureKit），实现 不抢占用户鼠标键盘 与 后台窗口操作/截图 ，向 Codex Computer Use 的体验对齐。 本文是 技术方案/评审稿 ，不含落地代码。决策点见",
    "locale": "zh",
    "navTitle": "Computer Use 原生化设计方案（Swift Helper）",
    "order": 900,
    "path": "/internals/computer-use-native-swift-design",
    "section": "internals",
    "slug": "internals/computer-use-native-swift-design",
    "sourcePath": "docs/internals/computer-use-native-swift-design.md",
    "title": "Computer Use 原生化设计方案（Swift Helper）"
  },
  {
    "description": "这份清单只列 自动化测不到、必须真人在真机上做 的项。 已自动化的部分（3000+ 单测、185 个 Swift 测试、平台路由、失败关闭、签名契约）见提交说明，不重复。 前置： bash native/cu-helper/build.sh 能出 .app ；或走 cd desktop && bun run build:sidecars 。",
    "locale": "zh",
    "navTitle": "Computer Use 原生重构 —— 真机验证清单",
    "order": 900,
    "path": "/internals/computer-use-native-manual-qa",
    "section": "internals",
    "slug": "internals/computer-use-native-manual-qa",
    "sourcePath": "docs/internals/computer-use-native-manual-qa.md",
    "title": "Computer Use 原生重构 —— 真机验证清单"
  },
  {
    "description": "配套文档(同目录,一起带走): - computer-use-codex-redesign.md —— 架构对比 + 重设计规格 + 对抗式审计(根因为什么慢/不顺/不准) - computer-use-codex-impl-blueprint.md —— 权威实现规格 (skyshot 精确文本格式 / 遍历 / 注入梯度 / 工具面 / stalenes",
    "locale": "zh",
    "navTitle": "Computer Use 重新设计 — 交接 context(新 worktree 从零开始用)",
    "order": 900,
    "path": "/internals/computer-use-handoff",
    "section": "internals",
    "slug": "internals/computer-use-handoff",
    "sourcePath": "docs/internals/computer-use-handoff.md",
    "title": "Computer Use 重新设计 — 交接 context(新 worktree 从零开始用)"
  }
]

export const imageSizes = {"/images/00runtime.png":[2736,2090],"/images/01-overall-architecture.png":[2048,1143],"/images/02-request-lifecycle.png":[2048,1143],"/images/03-tool-system.png":[2048,1143],"/images/04-multi-agent.png":[2048,1143],"/images/05-terminal-ui.png":[2048,1143],"/images/06-permission-security.png":[2048,1143],"/images/07-services-layer.png":[2048,1143],"/images/08-state-data-flow.png":[2048,1143],"/images/app/en/agent-create.webp":[2000,1255],"/images/app/en/composer-slash.webp":[2000,1255],"/images/app/en/h5-session.webp":[1206,2622],"/images/app/en/h5-sessions.webp":[1206,2622],"/images/app/en/permission-modes.webp":[2000,1255],"/images/app/en/pet-create.webp":[2000,1255],"/images/app/en/schedule-create.webp":[2000,1255],"/images/app/en/session-main.webp":[2000,1255],"/images/app/en/session-new.webp":[2000,1255],"/images/app/en/settings-agents.webp":[2000,1255],"/images/app/en/settings-computer-use.webp":[2000,1651],"/images/app/en/settings-general.webp":[2000,1255],"/images/app/en/settings-h5.webp":[2000,741],"/images/app/en/settings-im.webp":[2000,904],"/images/app/en/settings-pets.webp":[2000,1255],"/images/app/en/settings-provider-add.webp":[2000,1255],"/images/app/en/settings-usage.webp":[2000,1255],"/images/app/en/skill-market.webp":[2000,1440],"/images/app/en/workspace-changes.webp":[2000,1255],"/images/app/en/workspace-diff.webp":[2000,1255],"/images/app/en/workspace-preview.webp":[2000,1255],"/images/app/zh-CN/agent-create.webp":[2000,1255],"/images/app/zh-CN/composer-slash.webp":[2000,1255],"/images/app/zh-CN/h5-session.webp":[1206,2622],"/images/app/zh-CN/h5-sessions.webp":[1206,2622],"/images/app/zh-CN/permission-modes.webp":[2000,1255],"/images/app/zh-CN/pet-create.webp":[2000,1255],"/images/app/zh-CN/schedule-create.webp":[2000,1255],"/images/app/zh-CN/session-main.webp":[2000,1255],"/images/app/zh-CN/session-new.webp":[2000,1255],"/images/app/zh-CN/settings-agents.webp":[2000,1255],"/images/app/zh-CN/settings-computer-use.webp":[2000,1651],"/images/app/zh-CN/settings-general.webp":[2000,1255],"/images/app/zh-CN/settings-h5.webp":[2000,741],"/images/app/zh-CN/settings-im.webp":[2000,904],"/images/app/zh-CN/settings-pets.webp":[2000,1255],"/images/app/zh-CN/settings-provider-add.webp":[2000,1255],"/images/app/zh-CN/settings-usage.webp":[2000,1255],"/images/app/zh-CN/skill-market.webp":[2000,1440],"/images/app/zh-CN/workspace-changes.webp":[2000,1255],"/images/app/zh-CN/workspace-diff.webp":[2000,1255],"/images/app/zh-CN/workspace-preview.webp":[2000,1255],"/images/app-icon-dark.png":[1024,1024],"/images/app-icon-light.png":[1024,1024],"/images/app-icon.png":[1024,1024],"/images/banner.png":[2752,921],"/images/community/wechat-group-qr.png":[396,396],"/images/donate/bmc_button.png":[1090,306],"/images/donate/wechat_pay.jpeg":[1152,1152],"/images/donate/zfb_pay.png":[1193,1297],"/images/im/dingding/dingding01.png":[2880,1920],"/images/im/dingding/dingding02.png":[1206,2622],"/images/im/feishu/01-create-app-entry.png":[1792,1362],"/images/im/feishu/02-name-bot.png":[1266,1006],"/images/im/feishu/03-dev-console.png":[2562,1194],"/images/im/feishu/04-menu-enter.png":[3156,1814],"/images/im/feishu/05-menu-projects.png":[1936,1114],"/images/im/feishu/06-menu-new.png":[1756,1306],"/images/im/feishu/07-menu-clear.png":[1750,1326],"/images/im/feishu/08-menu-save.png":[2454,1754],"/images/im/feishu/09-publish-version.png":[2072,1294],"/images/im/feishu/10-fill-app-credentials.png":[2880,1920],"/images/im/feishu/11-generate-pairing-code.png":[2880,1920],"/images/im/feishu/12-pairing-code-detail.png":[1550,728],"/images/im/feishu/13-send-code-in-feishu.png":[2192,2116],"/images/im/feishu/14-pair-success.png":[1852,1788],"/images/im/feishu/15-pair-done.png":[2148,996],"/images/im/telegram/01-search-botfather.png":[2458,388],"/images/im/telegram/02-newbot-command.png":[1710,332],"/images/im/telegram/03-bot-token.png":[1706,1154],"/images/im/telegram/04-fill-bot-token.png":[2874,1916],"/images/im/telegram/05-generate-pairing-code.png":[2880,1920],"/images/im/telegram/06-pair-success.png":[1746,956],"/images/im/wechat/wechat01.png":[2880,1920],"/images/im/wechat/wechat02.jpg":[1179,2556],"/images/im/wechat/wechat03.png":[2880,1920],"/images/logo-horizontal-dark.png":[2200,640],"/images/logo-horizontal.png":[2200,640],"/images/mascots/bubu.png":[160,160],"/images/mascots/dada.png":[160,160],"/images/mascots/huhu.png":[160,160],"/images/mascots/huihui.png":[160,160],"/images/readme/agent-teams-en.webp":[1672,941],"/images/readme/agent-teams-zh.webp":[1672,941],"/images/readme/computer-use-en.webp":[1672,941],"/images/readme/computer-use-zh.webp":[1672,941],"/images/readme/cover-en.webp":[2172,724],"/images/readme/cover-zh.webp":[2172,724],"/images/readme/mobile-en.webp":[1672,941],"/images/readme/mobile-zh.webp":[1672,941],"/images/readme/models-en.webp":[1672,941],"/images/readme/models-zh.webp":[1672,941],"/images/readme/skills-en.webp":[1672,941],"/images/readme/skills-zh.webp":[1672,941],"/images/readme/workbench-en.webp":[1672,941],"/images/readme/workbench-zh.webp":[1672,941],"/images/sponsors/apismart-logo.png":[400,400],"/images/sponsors/aruhub-logo.png":[1254,1254],"/images/sponsors/atlascloud-logo-black.png":[720,118],"/images/sponsors/atlascloud-logo-white.png":[720,118],"/images/sponsors/kkvibe-logo.png":[720,240],"/images/sponsors/modelflare-banner-en.png":[4160,1080],"/images/sponsors/modelflare-banner-zh.png":[4160,1080],"/images/sponsors/modelflare-logo.png":[512,512],"/images/sponsors/moeapi-logo.png":[720,240]}

export const docsContent = {
  "/en/start": () => import('./content/en-start-index.js'),
  "/en/start/install": () => import('./content/en-start-install.js'),
  "/en/start/models": () => import('./content/en-start-models.js'),
  "/en/start/first-session": () => import('./content/en-start-first-session.js'),
  "/en/start/troubleshooting": () => import('./content/en-start-troubleshooting.js'),
  "/en/start/code-signing": () => import('./content/en-start-code-signing.js'),
  "/en/start/privacy": () => import('./content/en-start-privacy.js'),
  "/en/cases": () => import('./content/en-cases-index.js'),
  "/en/cases/explore-project": () => import('./content/en-cases-explore-project.js'),
  "/en/cases/fix-bug": () => import('./content/en-cases-fix-bug.js'),
  "/en/cases/ship-feature": () => import('./content/en-cases-ship-feature.js'),
  "/en/cases/daily-review": () => import('./content/en-cases-daily-review.js'),
  "/en/cases/phone-handoff": () => import('./content/en-cases-phone-handoff.js'),
  "/en/desktop": () => import('./content/en-desktop-index.js'),
  "/en/desktop/sessions": () => import('./content/en-desktop-sessions.js'),
  "/en/desktop/workspace": () => import('./content/en-desktop-workspace.js'),
  "/en/desktop/agents": () => import('./content/en-desktop-agents.js'),
  "/en/desktop/skills": () => import('./content/en-desktop-skills.js'),
  "/en/desktop/schedule": () => import('./content/en-desktop-schedule.js'),
  "/en/desktop/settings": () => import('./content/en-desktop-settings.js'),
  "/en/desktop/computer-use": () => import('./content/en-desktop-computer-use.js'),
  "/en/desktop/pets": () => import('./content/en-desktop-pets.js'),
  "/en/desktop/remote": () => import('./content/en-desktop-remote.js'),
  "/en/im": () => import('./content/en-im-index.js'),
  "/en/im/feishu": () => import('./content/en-im-feishu.js'),
  "/en/im/telegram": () => import('./content/en-im-telegram.js'),
  "/en/im/wechat": () => import('./content/en-im-wechat.js'),
  "/en/im/dingtalk": () => import('./content/en-im-dingtalk.js'),
  "/en/im/whatsapp": () => import('./content/en-im-whatsapp.js'),
  "/en/im/wecom": () => import('./content/en-im-wecom.js'),
  "/en/im/qq": () => import('./content/en-im-qq.js'),
  "/en/im/slack": () => import('./content/en-im-slack.js'),
  "/en/cli": () => import('./content/en-cli-index.js'),
  "/en/cli/reference": () => import('./content/en-cli-reference.js'),
  "/en/cli/env": () => import('./content/en-cli-env.js'),
  "/en/internals": () => import('./content/en-internals-index.js'),
  "/en/internals/desktop": () => import('./content/en-internals-desktop.js'),
  "/en/internals/server": () => import('./content/en-internals-server.js'),
  "/en/internals/structure": () => import('./content/en-internals-structure.js'),
  "/en/internals/agent": () => import('./content/en-internals-agent.js'),
  "/en/internals/agent-internals": () => import('./content/en-internals-agent-internals.js'),
  "/en/internals/agent-framework": () => import('./content/en-internals-agent-framework.js'),
  "/en/internals/skills": () => import('./content/en-internals-skills.js'),
  "/en/internals/skills-internals": () => import('./content/en-internals-skills-internals.js'),
  "/en/internals/memory": () => import('./content/en-internals-memory.js'),
  "/en/internals/memory-internals": () => import('./content/en-internals-memory-internals.js'),
  "/en/internals/autodream": () => import('./content/en-internals-autodream.js'),
  "/en/internals/computer-use": () => import('./content/en-internals-computer-use.js'),
  "/en/internals/channel": () => import('./content/en-internals-channel.js'),
  "/en/internals/contributing": () => import('./content/en-internals-contributing.js'),
  "/en/internals/computer-use-codex-impl-blueprint": () => import('./content/en-internals-computer-use-codex-impl-blueprint.js'),
  "/start": () => import('./content/start-index.js'),
  "/start/install": () => import('./content/start-install.js'),
  "/start/models": () => import('./content/start-models.js'),
  "/start/first-session": () => import('./content/start-first-session.js'),
  "/start/troubleshooting": () => import('./content/start-troubleshooting.js'),
  "/start/code-signing": () => import('./content/start-code-signing.js'),
  "/start/privacy": () => import('./content/start-privacy.js'),
  "/cases": () => import('./content/cases-index.js'),
  "/cases/explore-project": () => import('./content/cases-explore-project.js'),
  "/cases/fix-bug": () => import('./content/cases-fix-bug.js'),
  "/cases/ship-feature": () => import('./content/cases-ship-feature.js'),
  "/cases/daily-review": () => import('./content/cases-daily-review.js'),
  "/cases/phone-handoff": () => import('./content/cases-phone-handoff.js'),
  "/desktop": () => import('./content/desktop-index.js'),
  "/desktop/sessions": () => import('./content/desktop-sessions.js'),
  "/desktop/workspace": () => import('./content/desktop-workspace.js'),
  "/desktop/agents": () => import('./content/desktop-agents.js'),
  "/desktop/skills": () => import('./content/desktop-skills.js'),
  "/desktop/schedule": () => import('./content/desktop-schedule.js'),
  "/desktop/settings": () => import('./content/desktop-settings.js'),
  "/desktop/computer-use": () => import('./content/desktop-computer-use.js'),
  "/desktop/pets": () => import('./content/desktop-pets.js'),
  "/desktop/remote": () => import('./content/desktop-remote.js'),
  "/im": () => import('./content/im-index.js'),
  "/im/feishu": () => import('./content/im-feishu.js'),
  "/im/telegram": () => import('./content/im-telegram.js'),
  "/im/wechat": () => import('./content/im-wechat.js'),
  "/im/dingtalk": () => import('./content/im-dingtalk.js'),
  "/im/whatsapp": () => import('./content/im-whatsapp.js'),
  "/im/wecom": () => import('./content/im-wecom.js'),
  "/im/qq": () => import('./content/im-qq.js'),
  "/im/slack": () => import('./content/im-slack.js'),
  "/cli": () => import('./content/cli-index.js'),
  "/cli/reference": () => import('./content/cli-reference.js'),
  "/cli/env": () => import('./content/cli-env.js'),
  "/internals": () => import('./content/internals-index.js'),
  "/internals/desktop": () => import('./content/internals-desktop.js'),
  "/internals/server": () => import('./content/internals-server.js'),
  "/internals/structure": () => import('./content/internals-structure.js'),
  "/internals/agent": () => import('./content/internals-agent.js'),
  "/internals/agent-internals": () => import('./content/internals-agent-internals.js'),
  "/internals/agent-framework": () => import('./content/internals-agent-framework.js'),
  "/internals/skills": () => import('./content/internals-skills.js'),
  "/internals/skills-internals": () => import('./content/internals-skills-internals.js'),
  "/internals/memory": () => import('./content/internals-memory.js'),
  "/internals/memory-internals": () => import('./content/internals-memory-internals.js'),
  "/internals/autodream": () => import('./content/internals-autodream.js'),
  "/internals/computer-use": () => import('./content/internals-computer-use.js'),
  "/internals/channel": () => import('./content/internals-channel.js'),
  "/internals/contributing": () => import('./content/internals-contributing.js'),
  "/internals/computer-use-codex-impl-blueprint": () => import('./content/internals-computer-use-codex-impl-blueprint.js'),
  "/internals/computer-use-cef-injection": () => import('./content/internals-computer-use-cef-injection.js'),
  "/internals/computer-use-codex-redesign": () => import('./content/internals-computer-use-codex-redesign.js'),
  "/internals/computer-use-codex-parity-review": () => import('./content/internals-computer-use-codex-parity-review.js'),
  "/internals/computer-use-native-swift-design": () => import('./content/internals-computer-use-native-swift-design.js'),
  "/internals/computer-use-native-manual-qa": () => import('./content/internals-computer-use-native-manual-qa.js'),
  "/internals/computer-use-handoff": () => import('./content/internals-computer-use-handoff.js'),
}
